import { render, staticRenderFns } from "./CustomRequestList.vue?vue&type=template&id=b25420b4&scoped=true"
import script from "./CustomRequestList.vue?vue&type=script&lang=js"
export * from "./CustomRequestList.vue?vue&type=script&lang=js"
import style0 from "./CustomRequestList.vue?vue&type=style&index=0&id=b25420b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25420b4",
  null
  
)

export default component.exports